import { ReceptionHelpStep } from "./ReceptionHelpStep";

/**
 * Check-in step for unmatched eGK and stale-policy creation rejections: the
 * kiosk may not register the patient, so it hands over to the reception.
 *
 * @since 1.2.0
 * @example
 * ```tsx
 * <PatientCreationHandoffStep onComplete={() => undefined} />
 * ```
 */
export function PatientCreationHandoffStep({
  onComplete,
}: {
  /** Ends the check-in flow and returns to the start screen. */
  readonly onComplete: () => void;
}) {
  return (
    <ReceptionHelpStep
      onComplete={onComplete}
      testId="frontdesk-patient-creation-reception-handoff"
    />
  );
}
